/*jshint esversion: 6 */
// import Vue from 'vue';

// import axios from 'axios';
// import {extractErrorDetails} from '@/helpers/util.js';

// import router from '@/router/index';


const initialState = () => ({
  multiproject_calendar: {
    dates: [],
    calendar_weeks: [],
    months: [],
    lookup: {}
  }
});

// State object
const state = initialState();
// Getter functions
const getters = {
  getMultiProjectsByProject: (state, getters, rootState) => (project_id) => {
    let multiprojects = [];
    for (let i = 0; i < Object.keys(rootState.Ultra.multiprojects).length; i++) {
      let multiproject = rootState.Ultra.multiprojects[Object.keys(rootState.Ultra.multiprojects)[i]];
      if (multiproject.projects.includes(project_id)) {
        multiprojects.push(multiproject);
      }
    }
    return multiprojects;
  },
  getWorkPackagesByDate: (state, getters, rootState, rootGetters) => (datestr) => {
    // datestring -6 day and length 7
    let date_6 = new Date(datestr);
    date_6.setDate(date_6.getDate() - 6);
    let date_6_str = date_6.toISOString().substring(0,10);
    // datestring -5 day and length 6
    let date_5 = new Date(datestr);
    date_5.setDate(date_5.getDate() - 5);
    let date_5_str = date_5.toISOString().substring(0,10);
    // datestring -4 day and length 5
    let date_4 = new Date(datestr);
    date_4.setDate(date_4.getDate() - 4);
    let date_4_str = date_4.toISOString().substring(0,10);
    // datestring -3 day and length 4
    let date_3 = new Date(datestr);
    date_3.setDate(date_3.getDate() - 3);
    let date_3_str = date_3.toISOString().substring(0,10);
    // datestring -2 day and length 3
    let date_2 = new Date(datestr);
    date_2.setDate(date_2.getDate() - 2);
    let date_2_str = date_2.toISOString().substring(0,10);
    // datestring -1 day and length 2
    let date_1 = new Date(datestr);
    date_1.setDate(date_1.getDate() - 1);
    let date_1_str = date_1.toISOString().substring(0,10);
    // wagons that start on this date
    let wagons = Object.values(rootState.Ultra.twaggons).filter( (wagon) => {
      if (wagon.takt_start_date === datestr) {
        return true;
      }
      if (wagon.takt_start_date === date_1_str && wagon.length >= 2) {
        return true;
      }
      if (wagon.takt_start_date === date_2_str && wagon.length >= 3) {
        return true;
      }
      if (wagon.takt_start_date === date_3_str && wagon.length >= 4) {
        return true;
      }
      if (wagon.takt_start_date === date_4_str && wagon.length >= 5) {
        return true;
      }
      if (wagon.takt_start_date === date_5_str && wagon.length >= 6) {
        return true;
      }
      if (wagon.takt_start_date === date_6_str && wagon.length == 7) {
        return true;
      }
      return false;
    });
    let wps = [];
    for (let i = 0; i < wagons.length; i++) {
      wps = wps.concat(wagons[i].tworkpackages);
    }
    return rootGetters['Ultra/getUObjects']({type: 'tworkpackages', ids: wps});
  },
  getStatistics: (state, getters) => {
    let statistics = {max_takt_sum: 0, takt_values: []};
    for (let i = 0; i < Object.keys(state.multiproject_calendar.lookup).length; i++) {

      let wps = getters.getWorkPackagesByDate(Object.keys(state.multiproject_calendar.lookup)[i]);
      let values = [];
      let takt_sum = 0;
      for (let j = 0; j < wps.length; j++) {
        values.push({
          value: wps[j].manpower_planned,
          color: wps[j].color,
          icon: 'accessibility'
        });
        takt_sum += wps[j].manpower_planned;
      }
      if (statistics.max_takt_sum < takt_sum) {
        statistics.max_takt_sum = takt_sum;
      }
      statistics.takt_values.push({
        values: values,
        takt_sum: takt_sum
      });
    }
    return {
      statistics: statistics
    };
  }
};
// Actions
const actions = {
  initializeMPCalendar({commit, rootState, rootGetters}, payload) {
    let calendar = {
      dates: [],
      calendar_weeks: [],
      months: [],
      years: [],
      lookup: {}
    };
    let current_date = new Date(payload.start_date);
    let end_date = new Date(payload.end_date);
    let index = 0;
    while (current_date.getTime() <= end_date.getTime()) {

      // if rootState.View.multiproject_skip_weekends is true, skip weekends
      if (rootState.View.multiproject_skip_weekends && (current_date.getDay() === 0 || current_date.getDay() === 6)) {
        current_date.setDate(current_date.getDate() + 1);
        continue;
      }


      let current_date_string = current_date.toISOString();
      //lookup
      calendar.lookup[current_date_string.substring(0,10)] = index;
      //dates
      let day_string = `${rootState.Ultra.week_days[current_date.getDay()]} ${current_date_string.substring(8, 10)}`;
      let calendar_week = rootGetters['ProjectCalendar/getCalendarWeek'](current_date);
      calendar.dates.push({
        first_day_string: day_string,
        last_day_string: day_string,
        calendar_weeks: [calendar_week]
      });
      //calendar_weeks
      if (calendar.calendar_weeks.length === 0 || calendar.calendar_weeks[calendar.calendar_weeks.length-1].name !== calendar_week) {
        calendar.calendar_weeks.push({
          name: calendar_week,
          duration: 1
        });
      } else {
        calendar.calendar_weeks[calendar.calendar_weeks.length-1].duration++;
      }
      //Months
      let month_string = rootState.Ultra.months[current_date.getMonth()] + " '" + current_date.getFullYear().toString().substring(2,4);
      if (calendar.months.length === 0 || calendar.months[calendar.months.length-1].name !== month_string) {
        calendar.months.push({
          name: month_string,
          duration: 1
        });
      } else {
        calendar.months[calendar.months.length-1].duration++;
      }
      //Months
      let year_string = current_date.getFullYear().toString();
      if (calendar.years.length === 0 || calendar.years[calendar.years.length-1].name !== year_string) {
        calendar.years.push({
          name: year_string,
          duration: 1
        });
      } else {
        calendar.years[calendar.years.length-1].duration++;
      }

      //next step
      current_date.setDate(current_date.getDate() + 1);
      index++;
    }
    commit('set_mp_calendar', calendar);
  }
};
// Mutations
const mutations = {
  set_mp_calendar(state, calendar) {
    state.multiproject_calendar = calendar;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
